module.exports = __webpack_public_path__ + "static/media/list.1542fa19.svg";